import React from "react";
import RoundImageButton from "./RoundImageButton";

/**
 * จัดปุ่มรูปภาพเป็นแถวตาม group ที่ config กำหนด
 * แต่ละแถวเป็น CSS grid จึงตัดคอลัมน์เองตามความกว้างจริง
 * ไม่ต้อง slice จำนวนปุ่มต่อแถวใน JS
 *
 * renderCaption = ฟังก์ชันสร้างข้อความใต้ปุ่ม (ไม่ส่ง = ไม่มีข้อความใต้ปุ่ม)
 */
function RoundImageRows({ groups, selectedRobId, onSelect, renderCaption, className }) {
  return (
    <div className={`reg-rounds${className ? ` ${className}` : ""}`}>
      {groups.map((group) => (
        <div className="reg-rounds__group" key={group.key}>
          {group.label ? (
            <p className="reg-rounds__group-label">{group.label}</p>
          ) : null}
          <div className="reg-rounds__row">
            {group.items.map((round) => (
              <RoundImageButton
                key={round.key}
                round={round}
                caption={renderCaption ? renderCaption(round) : null}
                selectedRobId={selectedRobId}
                onSelect={onSelect}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default RoundImageRows;
